import { Flex, type FlexProps } from "@chakra-ui/react";
import { Text } from "./Text";
import { Icon } from "./icon";

interface BackButtonProps extends FlexProps {
  icon?: React.ReactNode;
  text: string;
  onClick: () => void;
  color?: string;
}

export const BackButton = ({ icon = <Icon.ArrowLeft size="1.2em" />, text, onClick, ...rest }: BackButtonProps) => {
  return (
    <Flex onClick={onClick} mb="5" align="center" cursor="pointer" {...rest}>
      {icon}
      <Text mb="0" ml="2.5">
        {text}
      </Text>
    </Flex>
  );
};
